export const ROOM_STATE_MAX_ALLOWED_USERS = 8

export const MAX_GROUP_NAME_LENGTH = 100

// Shared by the grade-appeal API validator and the form, so the student is
// stopped at the same limit the server enforces.
export const MAX_GRADE_APPEAL_JUSTIFICATION_LENGTH = 2000

export const GROUPING_SIZE_DEFAULT = 5
export const GROUPING_SIZE_MAXIMUM_DEFAULT = 5
export const GROUPING_SIZE_MINIMUM_DEFAULT = 1

export const PRE_MEETING_QUESTION_SLIDE_ID = 'pre-meeting-quiz'
